<template>
  <div class="card" ref="childCodes">
    <header class="card-header has-background-dark">
      <p class="card-header-title has-text-light">CHILD CODES</p>
    </header>
    <div class="card-content scrollable">
      <div class="content">
        <b-field>
          <base-select
            :service="$options.codeService"
            fetch-func="listTypes"
            label="Type"
            :value.sync="filters.type"
            value-key="type"
            label-key="type"
          />
        </b-field>
        <b-field>
          <b-button type="is-link" expanded @click.prevent="onFilter">FILTER</b-button>
        </b-field>
        <div class="columns m-t-20">
          <div class="column">
            <b-table
              :data="codes"
              :columns="$options.columns"
              :checked-rows.sync="checked"
              :loading="loading"
              checkable
            ></b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { CodeService } from "@/services/code.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  codeService: CodeService,
  components: {
    BaseSelect
  },
  props: [ 'firm' ],
  columns: [
    {
      field: "code",
      label: "Code"
    },
    {
      field: "name",
      label: "Name"
    },
    {
      field: "group",
      label: "Group"
    },
    {
      field: "type",
      label: "Type"
    }
  ],
  data: () => ({
    filters: { type: null },
    fullHeight: 0,
    checked: [],
    codes: [],
    loading: false
  }),
  computed: {
    mainBoxHeight() {
      const spacesOnTop = 170; // Filters box bot nargin
      return this.fullHeight - spacesOnTop;
    }
  },
  watch: {
    checked: {
      deep: true,
      handler: function() {
        this.$nextTick(() => {
          this.$emit("update:childCodeChecked", this.checked);
        });
      }
    }
  },
  mounted() {
    this.fullHeight = this.$refs.childCodes.clientHeight;
    this.fetchCodes();
  },
  methods: {
    async fetchCodes(filter) {
      const params = filter ? filter : {};
      params.firm_firm_id = this.firm.id
      params.active = 1
      this.loading = true;
      this.codes = await this.$options.codeService
        .all(params)
        .then(response => JsonDenormalizer.denormalize(response));
      this.loading = false;
    },
    onFilter() {
      this.$nextTick(async () => {
        this.fetchCodes(this.filters.type ? this.filters : null);
      });
    }
  }
};
</script>
<style scoped>
.scrollable {
  height: calc(90vh - 6rem);
}
.m-t-20 {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/codeConfigurator/partials/childCodes.vue